import { render, staticRenderFns } from "./NumberWithIncrementer.vue?vue&type=template&id=ef4b9412&scoped=true"
import script from "./NumberWithIncrementer.vue?vue&type=script&lang=ts"
export * from "./NumberWithIncrementer.vue?vue&type=script&lang=ts"
import style0 from "./NumberWithIncrementer.vue?vue&type=style&index=0&id=ef4b9412&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef4b9412",
  null
  
)

export default component.exports